import { render, staticRenderFns } from "./CertifiedApplicationForm.vue?vue&type=template&id=ba501aec"
import script from "./CertifiedApplicationForm.vue?vue&type=script&lang=js"
export * from "./CertifiedApplicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports